import Api from 'fou-api'
import BulkImportDef from 'fou-api/definitions/BulkImportResponse'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import BulkImportStatusDef from 'fou-api/definitions/BulkImportStatusResponse'

function getErrorMsg(error) {
  return (
    error.response?.data?.error ||
    error.response?.data?.message ||
    error.statusText ||
    error.message ||
    ''
  )
}

export default {
  namespaced: true,

  state: {
    bulkImportResult: {
      success: false,
      tempImportVersion: '',
      error: '',
      warning: ''
    },
    hasPosted: false,
    uploading: false,
    filename: '',
    showBulkImportStatus: false,
    bulkImportStatus: null,
    bulkImportError: '',
    tempImportVersion: ''
  },

  getters: {
    getResult: state => {
      return state.bulkImportResult
    },
    hasPosted: state => {
      return state.hasPosted
    },
    uploading: state => {
      return state.uploading
    },
    getFilename: state => {
      return state.filename
    },
    showBulkImportStatus: state => {
      return state.showBulkImportStatus
    },
    bulkImportStatus: state => {
      return state.bulkImportStatus
    },
    bulkImportError: state => {
      return state.bulkImportError
    },
    tempImportVersion: state => {
      return state.tempImportVersion
    }
  },

  mutations: {
    setResult (state, data) {
      let resp = BulkImportDef.build(data)
      state.bulkImportResult = resp
    },
    clear (state) {
      state.hasPosted = false
      state.uploading = false
      state.bulkImportResult.success = false
      state.bulkImportResult.tempImportVersion = ''
      state.bulkImportResult.error = ''
      state.bulkImportResult.warning = ''
      state.filename = ''
      state.showBulkImportStatus = false
      state.bulkImportStatus = null
      state.bulkImportError = ''
    },
    importComplete (state) {
      state.hasPosted = true
    },
    uploadStart (state) {
      state.uploading = true
    },
    uploadComplete (state) {
      state.uploading = false
    },
    setFilename (state, filename) {
      state.filename = filename
    },
    setHttpErrorMessage (state, error) {
      state.hasPosted = true
      state.bulkImportResult.success = false
      state.bulkImportResult.tempImportVersion = ''
      state.bulkImportResult.error = getErrorMsg(error)
    },
    setShowBulkImportStatus (state) {
      state.showBulkImportStatus = true
    },
    setBulkImportStatus (state, data) {
      state.bulkImportStatus = BulkImportStatusDef.build(data)
    },
    setBulkImportError (state, error) {
      state.bulkImportError = getErrorMsg(error)
    },
    setTempImportVersion (state, tempImportVersion) {
      state.tempImportVersion = tempImportVersion
    }
  },

  actions: {
    upload ({commit, state}, options) {
      return new Promise(resolve => {
        if (state.uploading) {
          resolve()
        }
        commit('uploadStart')
        commit('setFilename', options.file.name)
        Api.BulkImport.importBinaries(options.file)
          .then((response) => {
            commit('setResult', response.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('setHttpErrorMessage', err)
          })
          .finally(() => {
            commit('uploadComplete')
            commit('importComplete')
            resolve()
          })
      })
    },
    reset ({commit}) {
      return new Promise(resolve => {
        commit('clear')
        resolve()
      })
    },
    fetchImportStatus ({commit, state}, options) {
      return new Promise(resolve => {
        commit('setShowBulkImportStatus')
        commit('setTempImportVersion', options.tempImportVersion)
        commit('uploadStart')
        Api.BulkImport.bulkImportResult(options)
          .then((response) => {
            commit('setBulkImportStatus', response.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('setBulkImportError', err)
          })
          .finally(() => {
            resolve()
            commit('uploadComplete')
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
